import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';


import { ActivatedRoute, Router } from '@angular/router';
//import { ConsoleReporter } from 'jasmine';
import { title } from 'process';
import { lastValueFrom } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { MetaService } from 'src/app/shared/services/meta.service';

@Component({
	selector: 'molla-shop-sidebar-one',
	templateUrl: './shop-sidebar-one.component.html',
	styleUrls: ['./shop-sidebar-one.component.scss']
})

export class ShopSidebarOneComponent implements OnInit {

	@Input() toggle = false;
	shopData = [];
	params = {};
	priceRange: any = [0, 100];
	catsFilter = [];
	brandsFilter = [];
	cats = [];
	masterCats = [];
	title = "All products";
	description = "all products, vapes, vape, accessories, flavours, kits, online shop, cyprus";
	domainName:string;

	@ViewChild('priceSlider') priceSlider: any;

	constructor(public activeRoute: ActivatedRoute, public router: Router, public apiService:ApiService, private titleService:Title, private meta: Meta, private metaService:MetaService) {		
		activeRoute.queryParams.subscribe(params => {
			this.params = params;
			if (params['minPrice'] && params['maxPrice']) {
				this.priceRange = [
					params['minPrice'] / 10,
					params['maxPrice'] / 10
				]
			} else {
				this.priceRange = [0, 100];
				
				if(this.priceSlider) {
					this.priceSlider.slider.reset({min: 0, max: 100});
				}
			}
		})		
	}

	async ngOnInit(): Promise<void> {
		this.titleService.setTitle(this.title);
		if (typeof window !== 'undefined') {
			this.domainName = window.location.hostname;
		}
		this.metaService.updatePageMetaTags(this.domainName,'Products');
		document.getElementById('title').setAttribute("content",this.apiService.company_name + " " + this.title); 	
		//this.meta.updateTag({name:'keywords',content:'test test test'});
		//this.meta.updateTag({name:'description',content:'All vape shop products are shown in this page, depending on the category selected or brand'});
		//console.log(this.titleService.getTitle());
		if(typeof window !== 'undefined'){
			await this.apiService.fetchDBconnStringPromise();	
			this.fetchSidebarFilters();
			this.fetchBrandsFilters();
			this.cats = await this.apiService.setupMenuCategoriesandFetch();
			this.apiService.setupCategories4SideBar();
			this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		}
	}

	async fetchSidebarFilters(){
		let sb:string="";
		sb += " SELECT * ";
		sb += " FROM Product_Categories_Master  ";
		sb += " WHERE DELETEDFLAG = 0 ";
		sb += " ORDER BY PCM_Seq ASC ";

		this.catsFilter =  await lastValueFrom(this.apiService.execSqlQueryPromise(sb));
	}

	async fetchBrandsFilters(){
		let sb:string="";
		sb += " SELECT * ";
		sb += " FROM BRANDS ";
		sb += " WHERE DELETEDFLAG = 0 ";		

		this.brandsFilter =  await lastValueFrom(this.apiService.execSqlQueryPromise(sb));
	}


	containsAttrInUrl(type: string, value: string) {
		const currentQueries = this.params[type] ? this.params[type].split(',') : [];
		return currentQueries && currentQueries.includes(value);
	}

	getUrlForAttrs(type: string, value: string) {
		let currentQueries = this.params[type] ? this.params[type].split(',') : [];
		currentQueries = this.containsAttrInUrl(type, value) ? currentQueries.filter(item => item !== value) : [...currentQueries, value];
		return currentQueries.join(',');
	}

	onAttrClick(attr: string, value: string) {
		let url = this.getUrlForAttrs(attr, value);
		this.router.navigate([], { queryParams: { [attr]: this.getUrlForAttrs(attr, value), page: 1 }, queryParamsHandling: 'merge' });
	}

	filterPrice() {
		this.router.navigate([], { queryParams: { minPrice: this.priceRange[0] * 10, maxPrice: this.priceRange[1] * 10, page: 1 }, queryParamsHandling: 'merge' });
	}

	changeFilterPrice(value: any) {
		this.priceRange = [value[0], value[1]];
	}

	subCatClicked(subcat: any){
		this.router.navigate(['/shop/sidebar/list'], {
			queryParams: {subcategory: subcat.CatID, refresh: 'refresh'}
		 });
	}
}